import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

@inject("store")
@observer

export default class Lead extends React.Component {
  static propTypes = {
    event: PropTypes.shape({
      attributes: PropTypes.shape({
        id: PropTypes.number.isRequired,
        leadId: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        formattedTimeRange: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }

  render() {
    const { event, store } = this.props
    const { showBrands } = store
    const { id, leadId, title, formattedTimeRange, brandName } = event.attributes

    return (
      <a href={`/admin/leads/${leadId}`} className="calendar-event">
        <div>{ formattedTimeRange }</div>
        { showBrands &&
          <div>[{ brandName }]</div>
        }
        <div style={{fontWeight: "bold"}}>{ title }</div>
      </a>
    )
  }
}

